/**
 * API base URL for the backend (server: kliqplatform.vercel.app).
 * Set REACT_APP_API_URL=http://localhost:8800 for local dev.
 */
const BASE_URL = process.env.REACT_APP_API_URL || 'https://kliqplatform.vercel.app';

export default {
  BASE_URL,
};
